import axios from 'axios';
import { toast } from 'react-toastify';
import {
  ERROR,
  GET_APPLICATIONS_REPORT,
  GET_LEAD_REPORTS,
  GET_LIMIT_SANCTION_REPORT,
  GET_SUPPLIER_REPORT,
  GET_TRANCHE_REPORT,
  GET_DEMAND_REPORT,
  LOADER,
  GET_REPAYMENT_REPORT,
  GET_ACTIVE_CUSTOMER_REPORT,
  GET_APPLICATION_ANALYTICS,
  GET_PAYMENT_TRANSACTION_REPORT,
  GET_REPORT_VIEWS,
  GET_QUERY_MANAGEMENT_REPORT,
} from '../actionType';

const appendEach = (queryParams, key, value) => {
  if (Array.isArray(value)) {
    value.forEach((v) => {
      if (v !== '' && v !== null && v !== undefined) {
        queryParams.append(key, v);
      }
    });
  } else if (typeof value === 'string' && value.includes(',')) {
    value.split(',').forEach((v) => {
      const trimmed = v.trim();
      if (trimmed) {
        queryParams.append(key, trimmed);
      }
    });
  } else {
    queryParams.append(key, value);
  }
};

export const getLeadReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    let searchGlobalSearch = filters?.global_search || '';
    let searchLeadId = filters?.lead_id || '';

    if (searchGlobalSearch) {
      const trimmed = searchGlobalSearch.trim();
      // Match Lead ID format: starts with SFC, SFL, general letters + numbers, or purely numeric (length < 10)
      const isLeadId =
        (/^\d+$/.test(trimmed) && trimmed.length < 10) ||
        /^SFC/i.test(trimmed) ||
        /^SFL/i.test(trimmed) ||
        /^[A-Z]{3,}\d+$/i.test(trimmed);
      if (isLeadId) {
        searchLeadId = trimmed.toUpperCase();
        searchGlobalSearch = '';
      }
    }

    if (searchLeadId) {
      queryParams.append('lead_id', searchLeadId);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    // if (filters?.branch_name) {
    //   queryParams.append('branch_name', filters?.branch_name);
    // }

    // if (filters?.status) {
    //   queryParams.append('status', filters?.status);
    // }

    if (filters?.branch_name) {
      appendEach(queryParams, 'branch_name', filters?.branch_name);
    }

    if (filters?.status) {
      appendEach(queryParams, 'status', filters?.status);
    }

    if (filters?.created_from) {
      queryParams.append('created_from', filters?.created_from);
    }

    if (filters?.created_to) {
      queryParams.append('created_to', filters?.created_to);
    }

    if (searchGlobalSearch) {
      queryParams.append('global_search', searchGlobalSearch);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-lead-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_LEAD_REPORTS, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getApplicationsReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.application_id || filters?.seeds_id) {
      queryParams.append('application_id', filters?.application_id || filters?.seeds_id);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.branch_name) {
      queryParams.append('branch_name', filters?.branch_name);
    }

    if (filters?.staff_id) {
      queryParams.append('staff_id', filters?.staff_id);
    }

    if (filters?.stage) {
      queryParams.append('stage', filters?.stage);
    }

    if (filters?.current_application_bucket || filters?.parent_stage_name) {
      queryParams.append(
        'current_application_bucket',
        filters?.current_application_bucket || filters?.parent_stage_name,
      );
    }

    if (filters?.application_stage_name || filters?.stage) {
      queryParams.append(
        'application_stage_name',
        filters?.application_stage_name || filters?.stage,
      );
    }

    if (filters?.sector) {
      queryParams.append('sector', filters?.sector);
    }

    if (filters?.sub_sector) {
      queryParams.append('sub_sector', filters?.sub_sector);
    }

    if (filters?.created_from) {
      queryParams.append('created_from', filters?.created_from);
    }

    if (filters?.created_to) {
      queryParams.append('created_to', filters?.created_to);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-application-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_APPLICATIONS_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.pageSize || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getLimitSanctionReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.application_id) {
      queryParams.append('application_id', filters?.application_id);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.loan_id) {
      queryParams.append('loan_id', filters?.loan_id);
    }

    if (filters?.branch_name) {
      queryParams.append('branch_name', filters?.branch_name);
    }

    if (filters?.ro_created) {
      queryParams.append('ro_created', filters?.ro_created);
    }

    if (filters?.ro_assigned) {
      queryParams.append('ro_assigned', filters?.ro_assigned);
    }

    if (filters?.sanction_by) {
      queryParams.append('sanction_by', filters?.sanction_by);
    }

    if (filters?.loan_creation_from) {
      queryParams.append('loan_creation_from', filters?.loan_creation_from);
    }

    if (filters?.loan_creation_to) {
      queryParams.append('loan_creation_to', filters?.loan_creation_to);
    }

    if (filters?.is_signed) {
      queryParams.append('is_signed', filters?.is_signed);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-loan-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_LIMIT_SANCTION_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getTrancheReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.supplier_gst) {
      queryParams.append('supplier_gst', filters?.supplier_gst);
    }

    if (filters?.supplier) {
      queryParams.append('supplier', filters?.supplier);
    }

    if (filters?.branch) {
      queryParams.append('branch', filters?.branch);
    }

    if (filters?.status) {
      queryParams.append('status', filters?.status);
    }

    if (filters?.staff) {
      queryParams.append('staff', filters?.staff);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.lms_id) {
      queryParams.append('lms_id', filters?.lms_id);
    }

    if (filters?.tranche_id) {
      queryParams.append('tranche_id', filters?.tranche_id);
    }

    if (filters?.from_date) {
      queryParams.append('from_date', filters?.from_date);
    }

    if (filters?.to_date) {
      queryParams.append('to_date', filters?.to_date);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-tranche-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_TRANCHE_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getSupplierReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.supplier_id) {
      queryParams.append('supplier_id', filters?.supplier_id);
    }

    if (filters?.supplier_name) {
      queryParams.append('supplier_name', filters?.supplier_name);
    }

    if (filters?.branch) {
      queryParams.append('branch', filters?.branch);
    }

    if (filters?.supplier_status) {
      queryParams.append('supplier_status', filters?.supplier_status);
    }

    if (filters?.supplier_type) {
      queryParams.append('supplier_type', filters?.supplier_type);
    }

    if (filters?.supplier_gst) {
      queryParams.append('supplier_gst', filters?.supplier_gst);
    }

        if (filters?.supplier_email) {
      queryParams.append('supplier_email', filters?.supplier_email);
    }

    if (filters?.supplier_mobile_number) {
      queryParams.append('supplier_mobile_number', filters?.supplier_mobile_number);
    }

    if (filters?.from_date) {
      queryParams.append('from_date', filters?.from_date);
    }

    if (filters?.to_date) {
      queryParams.append('to_date', filters?.to_date);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-supplier-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_SUPPLIER_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getDemandReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.branch) {
      queryParams.append('branch', filters?.branch);
    }

    if (filters?.demand_type) {
      queryParams.append('demand_type', filters?.demand_type);
    }

    if (filters?.demand_month) {
      queryParams.append('demand_month', filters?.demand_month);
    }

    if (filters?.from_loan_date) {
      queryParams.append('from_loan_date', filters?.from_loan_date);
    }

    if (filters?.to_loan_date) {
      queryParams.append('to_loan_date', filters?.to_loan_date);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.loan_id) {
      queryParams.append('loan_id', filters?.loan_id);
    }

    if (filters?.app_id) {
      queryParams.append('app_id', filters?.app_id);
    }

    if (filters?.tranche_id) {
      queryParams.append('tranche_id', filters?.tranche_id);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-demand-report?${queryParams.toString()}`, { headers });
    dispatch({ type: GET_DEMAND_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getRepaymentReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.branch_name) {
      queryParams.append('branch_name', filters?.branch_name);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.loan_id) {
      queryParams.append('loan_id', filters?.loan_id);
    }

    if (filters?.ro_name) {
      queryParams.append('ro_name', filters?.ro_name);
    }

    if (filters?.co_borrower_phone_number) {
      queryParams.append(
        'co_borrower_phone_number',
        filters?.co_borrower_phone_number,
      );
    }

    if (filters?.customer_phone_number) {
      queryParams.append(
        'customer_phone_number',
        filters?.customer_phone_number,
      );
    }

    if (filters?.loan_creation_from) {
      queryParams.append('loan_creation_from', filters?.loan_creation_from);
    }

    if (filters?.loan_creation_to) {
      queryParams.append('loan_creation_to', filters?.loan_creation_to);
    }

    if (filters?.status) {
      queryParams.append('status', filters?.status);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/get-rps-report?${queryParams.toString()}`,
      { headers },
    );

    dispatch({ type: GET_REPAYMENT_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getActiveCustomerReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.branch_name) {
      queryParams.append('branch_name', filters?.branch_name);
    }

    if (filters?.customer_name) {
      queryParams.append('customer_name', filters?.customer_name);
    }

    if (filters?.customer_id) {
      queryParams.append('customer_id', filters?.customer_id);
    }

    if (filters?.loan_id) {
      queryParams.append('loan_id', filters?.loan_id);
    }

    if (filters?.app_id) {
      queryParams.append('app_id', filters?.app_id);
    }

    if (filters?.ro_name) {
      queryParams.append('ro_name', filters?.ro_name);
    }

    if (filters?.loan_created_from) {
      queryParams.append('loan_created_from', filters?.loan_created_from);
    }

    if (filters?.loan_created_to) {
      queryParams.append('loan_created_to', filters?.loan_created_to);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/get-active-customer-report?${queryParams.toString()}`,
      { headers },
    );

    dispatch({ type: GET_ACTIVE_CUSTOMER_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getApplicationSummary = (filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams();

    if (filters?.ro_id) {
      queryParams.append('ro_id', filters?.ro_id);
    }

    if (filters?.bcm_id) {
      queryParams.append('bcm_id', filters?.bcm_id);
    }

    if (filters?.bm_id) {
      queryParams.append('bm_id', filters?.bm_id);
    }

    if (filters?.parent_stage_name) {
      queryParams.append('parent_stage_name', filters?.parent_stage_name);
    }

    if (filters?.application_stage_name) {
      queryParams.append(
        'application_stage_name',
        filters?.application_stage_name,
      );
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/get-application-summary-report?${queryParams.toString()}`,
      { headers },
    );

    dispatch({
      type: GET_APPLICATION_ANALYTICS,
      payload: response?.data?.data,
    });
  } catch (err) {
    dispatch({ type: ERROR });
    toast.error('Error in fetching application analytics', err);
  }
};

export const getPaymentTransactionReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (filters?.merchant_order_id) {
      queryParams.append('merchant_order_id', filters?.merchant_order_id);
    }

    if (filters?.branch_code) {
      appendEach(queryParams, 'branch_code', filters?.branch_code);
    }

    if (filters?.order_id) {
      queryParams.append('order_id', filters?.order_id);
    }

    if (filters?.transaction_status) {
      queryParams.append('transaction_status', filters?.transaction_status);
    }

    if (filters?.phonepe_transaction_id) {
      queryParams.append(
        'phonepe_transaction_id',
        filters?.phonepe_transaction_id,
      );
    }

    if (filters?.phonepe_reference_id) {
      queryParams.append(
        'phonepe_reference_id',
        filters?.phonepe_reference_id,
      );
    }

    if (filters?.payment_mode) {
      queryParams.append('payment_mode', filters?.payment_mode);
    }

    if (filters?.payment_type) {
      queryParams.append('payment_type', filters?.payment_type);
    }

    if (filters?.remark) {
      queryParams.append('remark', filters?.remark);
    }

    if (filters?.completion_start_date) {
      queryParams.append(
        'completion_start_date',
        filters?.completion_start_date,
      );
    }

    if (filters?.completion_end_date) {
      queryParams.append('completion_end_date', filters?.completion_end_date);
    }

    if (filters?.creation_start_date) {
      queryParams.append('creation_start_date', filters?.creation_start_date);
    }

    if (filters?.creation_end_date) {
      queryParams.append('creation_end_date', filters?.creation_end_date);
    }

    if (filters?.global_search) {
      queryParams.append('global_search', filters?.global_search);
    }

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/payments-transaction-report?${queryParams.toString()}`,
      { headers },
    );

    dispatch({ type: GET_PAYMENT_TRANSACTION_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getQueryManagementReport = (page, limit, filters, isDownloaded) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  console.log({ filters, isDownloaded });

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    Object.entries(filters || {}).forEach(([key, value]) => {
      // include truthy values OR explicit boolean (true/false)
      if (value || typeof value === 'boolean') {
        queryParams.append(key, value);
      }
    });

    if (isDownloaded) {
      queryParams.append('is_downloaded', isDownloaded);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/get-qms-report?${queryParams.toString()}`,
      { headers },
    );

    dispatch({ type: GET_QUERY_MANAGEMENT_REPORT, payload: response?.data?.data })

    sessionStorage.setItem('reportsTotalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('reportsTotalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('reportsCurrentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('reportsLimit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    toast.error(err?.response?.data?.message);
  }
};

export const getReportViews = (clientId, moduleType, filters = {}) => async (dispatch) => {
  let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  let authToken = tokens?.token || null;

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams();

    if (filters.display_name) {
      queryParams.append('display_name', filters?.display_name);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/views/get-views/${clientId}/${moduleType}?${queryParams.toString()}`,
      { headers },
    );
    dispatch({ type: GET_REPORT_VIEWS, payload: response?.data?.data });
  } catch (err) {
    dispatch({ type: ERROR });
    toast.error('Error in fetching report views', err);
  }
};
